import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Outlet,
  useNavigate,
  Link,
} from "react-router-dom";
import Button from "@mui/material/Button";
// import  from "@mui/material/Link";
import Tab1 from "./Tab1";
import BottomTab from "./BottomTab";
import "../styles/LandingPage.css";
import axios from "axios";
import Api from "../Api/Api.json";
import "./Patients.css";
import Header from "../components/Header/Header";
import { Avatar } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPerson, faUser } from "@fortawesome/free-solid-svg-icons";
import { useQuery } from "@tanstack/react-query";
const mockApiData = [
  { id: 1, name: "John Doe", age: 25, phone: "123-456-7890" },
  { id: 2, name: "Jane Smith", age: 30, phone: "234-567-8901" },
  { id: 3, name: "Sam Wilson", age: 22, phone: "345-678-9012" },
  // Add more rows as needed
];

const RPMList = () => {
  // const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 15;
  const location = useLocation();
  const navigate = useNavigate();
  const fetchData = async () => {
    const response = await fetch(Api.TELEDOC_PROVIDER_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        // Add any required request body here
        task: "getRPMPatientList",
      }),
    });
    console.log(response);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  };
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["RPMPatientList"], // Unique key for this query
    queryFn: fetchData, // Function to fetch data
    staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
    cacheTime: 1000 * 60 * 10, // Cache data for 10 minutes
  });

  const handleClick = async (item) => {
    console.log(item.patient_id);
    await localStorage.setItem("patient_id", JSON.stringify(item.patient_id));
    await localStorage.setItem("patient_phone", JSON.stringify(item.phone));
    navigate(`/landing/tab2`);
  };

  // return <></>;
  return (
    <>
      <Header
        pageTitle={
          <div className="flex flex-row gap-2 items-center">
            <svg
              width="26"
              height="24"
              // className="mb-1"
              viewBox="0 0 26 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.87936 22.8C9.21224 22.8 9.55304 22.798 9.90128 22.798H16.4934C16.8411 22.798 17.1819 22.8 17.5148 22.8C20.565 22.8 22.8956 22.644 22.8956 19.4553C22.8956 16.1179 20.3432 13.378 17.0835 13.0802C17.0576 14.2478 13.1984 17.1292 13.1984 17.1292C13.1984 17.1292 9.33824 14.248 9.31208 13.0804C6.05288 13.378 3.5 16.1179 3.5 19.4553C3.5 22.644 5.82968 22.8 8.87936 22.8ZM16.0777 18.4456C16.0777 18.3506 16.1634 18.274 16.2699 18.274H17.3125V17.232C17.3125 17.1264 17.3886 17.0397 17.4836 17.0397H18.5125C18.607 17.0397 18.6836 17.1256 18.6836 17.232V18.2743H19.7257C19.8313 18.2743 19.9177 18.3508 19.9177 18.4459V19.4743C19.9177 19.5693 19.832 19.6459 19.7257 19.6459H18.6834V20.688C18.6834 20.794 18.6066 20.88 18.5118 20.88H17.4834C17.3883 20.88 17.3118 20.7943 17.3118 20.688V19.6456H16.2697C16.1636 19.6456 16.0774 19.5691 16.0774 19.474L16.0777 18.4456Z"
                fill="#18357A"
                fillOpacity="1"
              />
              <path
                d="M13.1997 13.918C16.1478 13.918 18.5375 9.48499 18.5375 6.53707C18.5375 3.58963 16.1478 1.19995 13.1997 1.19995C10.252 1.19995 7.8623 3.58963 7.8623 6.53707C7.8623 9.48499 10.252 13.918 13.1997 13.918Z"
                fill="#18357A"
                fillOpacity="1"
              />
            </svg>
            <span>Patients</span>
          </div>
        }
      />
      {isLoading ? (
        <div
          className="z-40 w-full flex justify-center items-center"
          style={{
            height: "calc(100vh - 210px)",
          }}
        >
          <div className="border-[6px] border-solid border-zinc-200 rounded-full border-t-[8px] border-t-[#3F4A9C] w-14 h-14 animate-spin"></div>
        </div>
      ) : (
        <div
          className="pb-4"
          style={{
            height: "calc(100vh - 113px)",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <div className="px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {data.map((patient) => (
                <div key={patient.patient_id}>
                  <div className="bg-white rounded-lg p-3 cardPaitent">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <Link
                          to={`/landing/rpm_list/${patient.patient_id}`}
                          className="no-underline"
                        >
                          {patient.imageSrc ? (
                            <img
                              src={patient.imageSrc}
                              alt=""
                              className="rounded-full"
                              style={{
                                width: "50px",
                                height: "50px",
                              }}
                            />
                          ) : (
                            <div
                              className="rounded-full text-white flex justify-center items-center"
                              style={{
                                width: "50px",
                                height: "50px",
                                fontSize: "24px",
                                backgroundColor: "#3F4A9C",
                              }}
                            >
                              {patient.name[0]}
                            </div>
                          )}
                        </Link>
                      </div>
                      <div className="flex-grow ml-3">
                        <div className="flex justify-between">
                          <Link
                            to={`/landing/rpm_list/${patient.patient_id}`}
                            className="no-underline"
                          >
                            <h4>{patient.name}</h4>
                          </Link>
                          <i className="fas fa-ellipsis-h"></i>
                        </div>
                        <div className="grid grid-cols-3">
                          <div className="col-span-2">
                            <label>
                              Patient No:{" "}
                              <span>
                                {/* PAT00 */}
                                {patient.patient_id}
                              </span>
                            </label>
                          </div>
                          <div>
                            <label>
                              Age: <span>{patient.age}</span>
                            </label>
                          </div>
                          <div className="col-span-3">
                            <label>
                              Phone: <span>{patient.phone}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 mt-2">
                      {/* <Button
												to={`/landing/rpm_list/${patient.patient_id}`}
												// className="text-decoration-none moreDetails"
												variant="outlined"
												component={Link}
											>
												See more
											</Button> */}
                      <Link
                        to={`/landing/rpm_list/${patient.patient_id}`}
                        className="text-decoration-none moreDetails"
                      >
                        See more
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {/* <div style={{ position: "fixed", bottom: 0, width: "100%" }}>
				<BottomTab />
			</div> */}
    </>
  );
};

export default RPMList;
